import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const loc = useLocation();

  if (user === null) {
    // still checking session
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen flex items-center justify-center bg-road-white"
      >
        <div className="text-steel text-sm tracking-wide">Checking session…</div>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  // F2B · Force first-login password change before entering the workspace.
  if (
    user &&
    typeof user === "object" &&
    user.must_change_password === true &&
    loc.pathname !== "/set-password"
  ) {
    return <Navigate to="/set-password" replace />;
  }
  return children;
};
